import { all } from 'redux-saga/effects'
import layoutSaga from './layoutSaga'
import authSaga from './authSaga'
import userSaga from './userSaga'

export default function* saga() {
  yield all([layoutSaga(), authSaga(), userSaga()])
}
